// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './EmailTemplateEditor.css';
import axios from 'axios';
import API_BASE_URL, { API_ENDPOINTS } from '../config/api';

// A mock order object to preview the template
const MOCK_ORDER = {
    customerName: "Harivishnu",
    orderId: "ORDER_123456",
    orderDate: "February 20, 2024",
    total: "₹2,500",
    currency: "INR",
    shippingAddress: "<strong>Harivishnu</strong><br>123 Tech Street, Silicon Valley<br>Hyderabad, Telangana<br>500081, India<br>Phone: +91 98765 43210",
    items: "App Development Course x 1<br>Design Bundle x 2",
    trackingLink: "https://www.harivishnu.in/track/ORDER_123456",
    blogTitle: "Top 5 Design Trends of 2024",
    blogLink: "https://www.harivishnu.in/blog/design/top-5-trends",
    podcastTitle: "Ep. 10: Mastering Creativity",
    podcastLink: "https://www.harivishnu.in/podcast/mastering-creativity",
    productTitle: "Limited Edition Sticker Pack",
    productLink: "https://www.harivishnu.in/store/sticker-pack"
};

const DEFAULT_HTML = `
    <div style="font-family: Arial, sans-serif; color: #333;">
        <h1>Thank you for your order.</h1>
        <p>Order Number: {{orderId}}</p>
        <p>Ordered On: {{orderDate}}</p>
        <hr />
        <h1>Items Purchased</h1>
        <p>{{items}}</p>
        <hr />
        <h1>Shipping Address</h1>
        <p>{{shippingAddress}}</p>
        <hr />
        <h1>Instructions</h1>
        <ol>
        <li>To track your order, visit&nbsp;<a href="https://www.harivishnu.in/order-history">https://www.harivishnu.in/order-history</a>.&nbsp;Enter your Order Number to find your receipt.</li>
        <li>For support from our team, send an email to <a href="mailto:support@harivishnu.in">support@harivishnu.in</a>&nbsp;along with your order-number. Our team will do our best to help you.</li>
        </ol>
        <hr />
        <h1>Our Latest Content</h1>
        <p>Blog: <a href="{{blogLink}}">{{blogTitle}}</a></p>
        <p>Podcast: <a href="{{podcastLink}}">{{podcastTitle}}</a></p>
        <p>Store: <a href="{{productLink}}">{{productTitle}}</a></p>
    </div>`;

export default function EmailTemplateEditor() {
    const { documentId } = useParams();
    const isEditMode = !!documentId;
    const navigate = useNavigate();

    const [template, setTemplate] = useState({
        templateName: '',
        subject: '',
        htmlContent: DEFAULT_HTML,
        isActive: true
    });
    const [loading, setLoading] = useState(isEditMode);
    const [saving, setSaving] = useState(false);
    const [previewHtml, setPreviewHtml] = useState('');

    useEffect(() => {
        if (isEditMode) {
            fetchTemplate();
        } else {
            updatePreview(DEFAULT_HTML);
        }
    }, [documentId]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        updatePreview(template.htmlContent);
    }, [template.htmlContent]);

    const fetchTemplate = async () => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem('token');
            const res = await axios.get(
                API_ENDPOINTS.ADMIN.COLLECTION_GET('EmailTemplates', documentId),
                { headers: token ? { Authorization: `Bearer ${token}` } : {} }
            );
            if (res.data && res.data.data) {
                const doc = res.data.data;
                setTemplate({
                    templateName: doc.templateName || '',
                    subject: doc.subject || '',
                    htmlContent: doc.htmlContent || DEFAULT_HTML,
                    isActive: doc.isActive !== undefined ? doc.isActive : true
                });
            }
        } catch (error) {
            console.error('Error fetching template:', error);
            alert('Failed to load template.');
        } finally {
            setLoading(false);
        }
    };

    const updatePreview = (html) => {
        if (!html) return;
        let rendered = html;
        Object.keys(MOCK_ORDER).forEach(key => {
            const regex = new RegExp(`{{${key}}}`, 'g');
            rendered = rendered.replace(regex, MOCK_ORDER[key]);
        });
        setPreviewHtml(rendered);
    };

    const handleSave = async () => {
        if (!template.templateName.trim()) {
            alert('Template name is required.');
            return;
        }
        setSaving(true);
        try {
            const token = sessionStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : {};

            if (isEditMode) {
                await axios.put(`${API_BASE_URL}/store/EmailTemplates/${documentId}`, template, { headers });
            } else {
                await axios.post(`${API_BASE_URL}/store/EmailTemplates`, template, { headers });
            }
            alert('Template saved successfully!');
            navigate('/admin/database/storedb/EmailTemplates');
        } catch (error) {
            console.error('Error saving template:', error);
            alert('Failed to save template.');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="loading-spinner flex min-h-[200px] items-center justify-center text-[0.95rem] text-[#666]">Loading template...</div>;

    return (
        <div className="email-editor-container mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-[16px] px-[12px] py-[12px] xl:grid-cols-[1fr_1fr]">
            <div className="email-editor-form rounded-[12px] border border-slider bg-bg p-[14px] shadow-[0_2px_10px_rgba(0,0,0,0.06)]">
                <div className="editor-header mb-[12px] flex items-center justify-between gap-[10px]">
                    <div>
                        <Link
                            to="/admin/database/storedb/EmailTemplates"
                            style={{ color: '#6b7280', textDecoration: 'none', fontSize: '14px' }}
                        >
                            ← Back to EmailTemplates
                        </Link>
                        <h2 style={{ marginTop: 8 }}>{isEditMode ? 'Edit Template' : 'New Template'}</h2>
                    </div>
                    <button className="save-btn rounded-[8px] border border-slider bg-[#111827] px-[14px] py-[8px] text-[0.9rem] font-[600] text-white" onClick={handleSave} disabled={saving}>
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </div>

                <div className="form-group mb-[10px] flex flex-col gap-[6px]">
                    <label>Template Name</label>
                    <input
                        type="text"
                        value={template.templateName}
                        onChange={(e) => setTemplate({ ...template, templateName: e.target.value })}
                        placeholder="e.g. ORDER_RECEIPT"
                        disabled={isEditMode}
                    />
                </div>

                <div className="form-group mb-[10px] flex flex-col gap-[6px]">
                    <label>Email Subject</label>
                    <input
                        type="text"
                        value={template.subject}
                        onChange={(e) => setTemplate({ ...template, subject: e.target.value })}
                    />
                </div>

                <div className="form-group mb-[10px] flex flex-col gap-[6px]">
                    <label>
                        <input
                            type="checkbox"
                            checked={template.isActive}
                            onChange={(e) => setTemplate({ ...template, isActive: e.target.checked })}
                            style={{ marginRight: 6 }}
                        />
                        Active
                    </label>
                </div>

                <div className="form-group mb-[10px] flex flex-col gap-[6px]">
                    <label>HTML Content</label>
                    <textarea
                        value={template.htmlContent}
                        onChange={(e) => setTemplate({ ...template, htmlContent: e.target.value })}
                    />
                    <small>Available variables: {"{{customerName}}"}, {"{{orderId}}"}, {"{{total}}"}, {"{{items}}"}, {"{{trackingLink}}"}, {"{{blogTitle}}"}, {"{{blogLink}}"}, {"{{podcastTitle}}"}, {"{{podcastLink}}"}, {"{{productTitle}}"}, {"{{productLink}}"}</small>
                </div>
            </div>

            <div className="email-editor-preview rounded-[12px] border border-slider bg-bg p-[14px] shadow-[0_2px_10px_rgba(0,0,0,0.06)]">
                <h3>Live Preview</h3>
                <div className="email-preview-frame h-[70vh] overflow-hidden rounded-[10px] border border-slider bg-white">
                    <iframe
                        title="Email Preview"
                        srcDoc={previewHtml}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    />
                </div>
            </div>
        </div>
    );
}
